import React from "react";
import classnames from "classnames";
import { BUTTON_HEIGHT_REGULAR, getShimmerClass } from "utils/constants/ui";

const EditorHeaderLoader = ({ withShimmer }) => {
  const shimmerClass = getShimmerClass(withShimmer);

  return (
    <div className="w-100 flex justify-between pa2 items-center bb hairline-1 bg-white">
      <div className="flex flex-row items-start">
        <div className={`h2 w2 ${shimmerClass}`}></div>
        <div className={`ml2 h2 w3 ${shimmerClass}`}></div>
      </div>
      <div className="flex flex-row items-center">
        {new Array(4).fill("").map((_, stubIx) => (
          <div
            key={stubIx}
            className={classnames(`h2 w3 ${shimmerClass}`, {
              "ml2": stubIx,
              "dn db-ns": stubIx >= 2
            })}
          ></div>
        ))}
      </div>
      <div className="flex flex-row items-center">
        <div className="h-100 bl bw1 b--black mh2"></div>
        <div className="flex flex-row">
          <div
            style={{ height: BUTTON_HEIGHT_REGULAR }}
            className={`h2 w2 ${shimmerClass}`}
          ></div>
          <div
            style={{ height: BUTTON_HEIGHT_REGULAR }}
            className={`ml2 h2 w3 ${shimmerClass}`}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default EditorHeaderLoader;
